import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Testimonial.css"; // Import your CSS file
import testi1 from "../Images/testimonial-1.jpg"
import testi2 from "../Images/testimonial-2.jpg"
import testi3 from "../Images/testimonial-4.jpg"

const Testimonial = () => {
  return (
    <div className="testimonial-section container-xxl py-5">
      <div className="container py-5 px-lg-5">
        <p className="section-title text-secondary justify-content-center">
          <span></span><span></span>
        </p>
        <h1 className="text-center mb-5">What Say Our Followers!</h1>

        <OwlCarousel
          className="owl-theme testimonial-carousel"
          loop
          margin={10}
          nav
          dots={true}
          autoplay={true}
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 2 }
          }}
        >
          {/* Testimonial Item 1 */}
          <div className="testimonial-item bg-light rounded my-4 p-4">
            <p className="fs-5">
              <i className="fa fa-quote-left fa-2x text-primary me-3"></i>
              Fusionsphere is my secret weapon to grow my personal training business. I get thousands of high quality followers a month, and they convert to paying customers!
            </p>
            <div className="d-flex align-items-center">
              <img
                className="img-fluid flex-shrink-0 rounded-circle"
                src={testi1}
                alt="Client"
                style={{ width: "65px", height: "65px" }}
              />
              <div className="ps-4">
                <h5 className="mb-1">Daniela.A</h5>
                {/* <span>Profession</span> */}
              </div>
            </div>
          </div>

          {/* Testimonial Item 2 */}
          <div className="testimonial-item bg-light rounded my-4 p-4">
            <p className="fs-5">
              <i className="fa fa-quote-left fa-2x text-primary me-3"></i>
              We’re a fitness and health brand, and in our competitive space, followers and engagement are crucial. We went from 5,800 followers to 42,000 in less than 4 months, and our engagement rate is at an all time high.
            </p>
            <div className="d-flex align-items-center">
              <img
                className="img-fluid flex-shrink-0 rounded-circle"
                src={testi2}
                alt="Client"
                style={{ width: "65px", height: "65px" }}
              />
              <div className="ps-4">
                <h5 className="mb-1">@JohnGrant</h5>
                {/* <span>Profession</span> */}
              </div>
            </div>
          </div>

          {/* Testimonial Item 3 */}
          <div className="testimonial-item bg-light rounded my-4 p-4">
            <p className="fs-5">
              <i className="fa fa-quote-left fa-2x text-primary me-3"></i>
              We’re a fitness and health brand, and in our competitive space, followers and engagement are crucial. We went from 5,800 followers to 42,000 in less than 4 months, and our engagement rate is at an all time high.
            </p>
            <div className="d-flex align-items-center">
              <img
                className="img-fluid flex-shrink-0 rounded-circle"
                src={testi3}
                alt="Client"
                style={{ width: "65px", height: "65px" }}
              />
              <div className="ps-4">
                <h5 className="mb-1">springerminia</h5>
                {/* <span>Profession</span> */}
              </div>
            </div>
          </div>
        </OwlCarousel>
      </div>
    </div>
  );
};

export default Testimonial;
